module.exports = __webpack_public_path__ + "img/BIO_RED.193d1759.png";